"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _DialogWrap = _interopRequireDefault(require("./DialogWrap"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// based on vc-dialog 7.5.14
var _default = _DialogWrap.default;
exports.default = _default;